// extracted by mini-css-extract-plugin
export default {"share-mask-container":"index_share-mask-container__7YRx0","share-guide":"index_share-guide__7KRHN"};